import * as React from 'react';
import {formatPrice, declineNumeric} from '../../../helpers/format_helper';

interface IProps {
  url: string;
  rootTitle: string;
  objectCount: number;
  h1: string;
  title: string;
}

const s = require('../vertical_promo_blocks.css');

export class GeneralPromoLink extends React.Component<IProps> {
  public render() {
    return (
      <a className={`${s['c-new-promo-block-content-link-item']}`} href={this.props.url}>
        <div className={s['c-new-promo-block-link-content']}>
          <h5
            className={s['c-new-promo-block-content-link-title']}
            dangerouslySetInnerHTML={{__html: this.props.rootTitle}}/>
          <span className={s['c-new-promo-block-content-link-text']}>
            {formatPrice(this.props.objectCount, 4) + ' '
            + declineNumeric(this.props.objectCount, ['предложение', 'предложения', 'предложений'])}
            </span>
        </div>
      </a>
    );
  }
}
